<div id="app-modal-container"
     class="app-modal-container"
     (click)="clickOutModal($event)">

  <section class="app-modal" [style.max-width]="size==='medium' ? '800px' : ''" [style.margin]="'auto'">

    <!-- HEADER -->
    <article class="app-modal-header">
      <h1 class="app-modal-title">
        {{ modalTitle }}
      </h1>
      <app-dialog-close-button (closeModal)="closeModal()"></app-dialog-close-button>
    </article>

    <!-- BODY -->
    <article class="app-modal-body">
      <ng-content select="[modal-body]"></ng-content>
    </article>

    <!-- FOOTER -->
    <article *ngIf="showFooter" class="app-modal-footer">
      <ng-content select="[modal-footer]"></ng-content>
    </article>

  </section>

</div>
